import { useState, useEffect, useCallback } from 'react';
import { GAME_CONSTANTS } from '../constants';

export interface CharacterStateOptions {
  activeDuration?: number; // 激活状态持续时间（毫秒）
  autoResetToIdle?: boolean; // 是否自动重置为待机状态
}

export const useCharacterState = (options: CharacterStateOptions = {}) => {
  const {
    activeDuration = GAME_CONSTANTS.DEFAULT_CHARACTER_ACTIVE_DURATION,
    autoResetToIdle = true
  } = options;

  const [isActive, setIsActive] = useState(false);
  const [lastActivatedTime, setLastActivatedTime] = useState<number>(0);

  // 激活角色状态
  const activate = useCallback(() => {
    setIsActive(true);
    setLastActivatedTime(Date.now());
  }, []);

  // 手动重置为待机状态
  const resetToIdle = useCallback(() => {
    setIsActive(false);
  }, []);

  // 自动重置逻辑
  useEffect(() => {
    if (!autoResetToIdle || !isActive) return;

    const timer = setTimeout(() => {
      setIsActive(false);
    }, activeDuration);

    return () => clearTimeout(timer);
  }, [isActive, activeDuration, autoResetToIdle]);

  return {
    isActive,
    activate,
    resetToIdle,
    lastActivatedTime
  };
};